module.exports = __webpack_public_path__ + "img/nepali_thali.jpeg";